import type { IRoute } from "@/common/types/router"

export type Names = {
    root
    vacancies
    vacancy
    result
    candidates
    candidate
    interviewRequests
    interviewRequestReports
    personnelOfficers
    testings
    login
}

const route: IRoute<Names> = {
    root: {
        path: "/recruiter",
        name: "root"
    },
    vacancies: {
        path: "vacancies",
        name: "vacancies",
        meta: {
            excludeUserTypes: ["personnel_officer"]
        }
    },
    vacancy: {
        path: "vacancies/:id",
        name: "vacancy",
        meta: {
            excludeUserTypes: ["personnel_officer"]
        }
    },
    result: {
        path: "results/:id",
        name: "result",
        meta: {
            excludeUserTypes: ["personnel_officer"]
        }
    },
    candidates: {
        path: "candidates",
        name: "candidates",
        meta: {
            excludeUserTypes: ["personnel_officer"]
        }
    },
    candidate: {
        path: "candidates/:id",
        name: "candidate",
        meta: {
            excludeUserTypes: ["personnel_officer"]
        }
    },
    interviewRequests: {
        path: "interview-requests",
        name: "interviewRequests",
        meta: {
            includeVariants: ["cooper"],
            excludeUserTypes: ["personnel_officer"]
        }
    },
    interviewRequestReports: {
        path: "interview-requests-reports",
        name: "interviewRequestsReports",
        meta: {
            includeVariants: ["cooper"],
            excludeUserTypes: ["personnel_officer"]
        }
    },
    personnelOfficers: {
        path: "personnel-officers",
        name: "personnelOfficers",
        meta: {
            includeVariants: ["cooper"],
            includeUserTypes: ["recruiter"]
        }
    },
    testings: {
        path: "testings",
        name: "testings",
        meta: {
            includeVariants: ["cooper"],
            includeUserTypes: ["personnel_officer"]
        }
    },
    login: {
        path: "/recruiter/login",
        name: "login"
    }
}

export default route
